const C = {
  name: "Apps",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16 1C14.3477 1 13 2.34772 13 4V8C13 9.65228 14.3477 11 16 11H20C21.6523 11 23 9.65228 23 8V4C23 2.34772 21.6523 1 20 1H16ZM15 4C15 3.45228 15.4523 3 16 3H20C20.5477 3 21 3.45228 21 4V8C21 8.54772 20.5477 9 20 9H16C15.4523 9 15 8.54772 15 8V4Z" fill="currentColor"/>
<path d="M4 13C2.34772 13 1 14.3477 1 16V20C1 21.6523 2.34772 23 4 23H8C9.65228 23 11 21.6523 11 20V16C11 14.3477 9.65228 13 8 13H4ZM3 16C3 15.4523 3.45228 15 4 15H8C8.54772 15 9 15.4523 9 16V20C9 20.5477 8.54772 21 8 21H4C3.45228 21 3 20.5477 3 20V16Z" fill="currentColor"/>
<path d="M1 4C1 2.34772 2.34772 1 4 1H8C9.65228 1 11 2.34772 11 4V8C11 9.65228 9.65228 11 8 11H4C2.34772 11 1 9.65228 1 8V4ZM4 3C3.45228 3 3 3.45228 3 4V8C3 8.54772 3.45228 9 4 9H8C8.54772 9 9 8.54772 9 8V4C9 3.45228 8.54772 3 8 3H4Z" fill="currentColor"/>
<path d="M16 13C14.3477 13 13 14.3477 13 16V20C13 21.6523 14.3477 23 16 23H20C21.6523 23 23 21.6523 23 20V16C23 14.3477 21.6523 13 20 13H16ZM15 16C15 15.4523 15.4523 15 16 15H20C20.5477 15 21 15.4523 21 16V20C21 20.5477 20.5477 21 20 21H16C15.4523 21 15 20.5477 15 20V16Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as Apps
};
